/* eslint-disable no-underscore-dangle */
/* eslint-disable consistent-return */
/* eslint-disable react/forbid-prop-types */
import MaterialTable from 'material-table';
import React from 'react';
import PropTypes from 'prop-types';
import { List, ListItem } from '@material-ui/core';
import userServices from '../../../../redux/services/userServices';

const StudentsList = ({ loadData, groupId, students }) => (
  <MaterialTable
    title="Students in Company"
    data={students}
    style={{
      width: '48%',
      height: '100%',
      zIndex: 0,
    }}
    columns={[
      {
        title: 'Last name',
        field: 'name',
      },
      {
        title: 'First name',
        field: 'firstname',
      },
      {
        title: 'Email',
        field: 'email',
      },
      {
        title: 'Needs',
        field: 'needs',
        hidden: true,
        hiddenByColumnsButton: true,
        width: '10%',
        render: (rowData) => {
          if (rowData.needs !== null && rowData.needs !== undefined) {
            const needs = Object.entries(rowData.needs);
            return (
              <List>
                {
                  needs.map((item) => (
                    <>
                      {item[1] && !item[0].includes('other') && !item[0].includes('objectives')
                        ? <ListItem>{ item[0] }</ListItem>
                        : <div />}
                    </>
                  ))
                }
              </List>
            );
          }
        },
      },
    ]}
    options={{
      columnsButton: true,
      selection: true,
      pageSize: 10,
    }}
    actions={[
      {
        icon: 'add',
        tooltip: 'Add students to group',
        onClick: async (event, rowData) => {
          await Promise.all(rowData.map(async (student) => {
            await userServices.addUsersToGroup(groupId, student._id);
          }));
          loadData();
        },
      },
    ]}
  />
);

StudentsList.propTypes = {
  students: PropTypes.array.isRequired,
  groupId: PropTypes.string.isRequired,
  loadData: PropTypes.func.isRequired,
};

export default StudentsList;
